export const sortBy = (key) => {
  return (a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0)
}

export const sumBy = (arr, key) => {
  return arr.reduce((acc, item) => acc + item[key], 0)
}

export const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length

export const getProperty = (o, s) => {
  s = s.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
  s = s.replace(/^\./, '') // strip a leading dot
  const a = s.split('.')

  for (var i = 0, n = a.length; i < n; ++i) {
    const k = a[i]

    if (k in o) {
      o = o[k]
    } else {
      return
    }
  }
  return o
}
